import {http} from 'lib/httpAxios'

export default {
  retrievePerishableProductsModes () {
    return http.get(`/products/expiring/modes/`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrievePerishableProductsList (parameters) {
    return http.post(`/products/expiring/`, parameters)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/products.js